__turbopack_context__.v({
  "header": "header-module-scss-module__JbAT2W__header",
  "header-fallback": "header-module-scss-module__JbAT2W__header-fallback",
  "header-wrapper": "header-module-scss-module__JbAT2W__header-wrapper",
  "header-wrapper--has-sub-menu": "header-module-scss-module__JbAT2W__header-wrapper--has-sub-menu",
  "header-wrapper--secondary": "header-module-scss-module__JbAT2W__header-wrapper--secondary",
});
